<div [style.width]="width" [style.height]="height" class="hoverPanel" [class]="{'top': position == 'top', 'bottom': position == 'bottom'}" #hoverPanel [style.top.px]="top" [style.left.px]="left" [style.zIndex]="zIndex">
    <div #hoverPanelView [style.maxWidth]="maxWidth" class="templateContainer">
        <ng-container *ngTemplateOutlet="template"></ng-container>
    </div>
</div>